module.exports = __webpack_public_path__ + "media/images/facebook-d97c4999e215f5335d611ab268460660.svg";